import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { PRICE_SCHEDULE_MODES,LEGACY_SCREEN_VIEW, NO_CHANGE_OF_INFO } from "../../common_nextgen/utils/Constants";
//import ConfirmationModal from '../../../common_nextgen/common_components/Modal/ConfirmationModal';
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
  LegacyResolvers,
} from "../../common_nextgen/utils/UtilFunctions";
import { formFields } from "./DeductibleScheduleStepsConfig";
import { useModal } from "../../common_nextgen/hooks/ModalContext";
const {
  PATIENT_PAY_SCHEDULES,
  DEDUCTIBLE_SCHEDULE_STEP_DETAIL_EXTENSION,
  DEDUCTIBLE_SCHEDULE_STEPS,
} = ROUTE_PATHS;

const screenInfo = {
  ADD: ["Add Deductible Schedule Step", "RCDSD003"],
  CHANGE: ["Deductible Schedule Step Detail", "RCDSD002"],
  VIEW: ["Deductible Schedule Step Detail", "RCDSD002"],
};

const DeductibleScheduleStepsForm = ({ mode }) => {
  const location = useLocation();
  const navigateToPage = useCustomNavigate();
  const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  //console.log("current state in form", currentState, previousState);
  let {
    selectedSteps = [],
    previousScreen = DEDUCTIBLE_SCHEDULE_STEPS,
    currentIndex: initialIndex = 0,
    paramsData,
    scheduleName = "",
  } = currentState;
  console.log("current state", currentState);

  //const [selectedOption, setSelectedOption] = useState('no');
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [initialFormData, setInitialFormData] = useState({});
  //const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  //const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const toast = useToast();
  // const [dsdCrossOverFlag, setDsdCrossOverFlag] = useState("");
  const { axios_helper_no_header } = useAxios();

  const handleBack = useCallback(() => {
    if (currentIndex < selectedSteps.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      const [latestPreviousState] = previousState.splice(
        previousState.length - 1,
        1
      );
      let { paramsData } = latestPreviousState;
      console.log("paramsData", paramsData, latestPreviousState);
      const updatedParamsData = {
        ...paramsData,
        dscScheduleName: scheduleName,
      };
      const updatedLatestPreviousState = {
        ...latestPreviousState,
        initialParamsData: updatedParamsData,
      };
      navigateToPage(previousScreen, [
        ...previousState,
        updatedLatestPreviousState,
      ]);
    }
  }, [currentIndex, selectedSteps]);

  // const openConfirmationModal = () => setIsConfirmationModalOpen(true);
  // const closeConfirmationModal = () => setIsConfirmationModalOpen(false);

  /* Lookup data */
  const { showModal } = useModal();
  const [lookupData, setLookupData] = useState({});
  const handleReceiveData = (data) => {
    //setInitialFormData({ ...initialFormData, ...data });
    if (data && Object.keys(data).length) {
      setLookupData(data);
    }
  };
  const fetchLookupData = (lookupScreen, params, formData) => {
     const updatedFormData = { ...formData };
     if (lookupScreen.default === "RCPLN018" && formData.planCode === "") {
       updatedFormData.planEffDate = "";
       updatedFormData.planName = "";
     }
     showModal(lookupScreen, { params }, handleReceiveData, updatedFormData);
  };

  const viewLookupDetails = (lookupScreen, params, formData) => {
    const { viewType, fieldMapping } = params;
    const { default: screenNumber } = lookupScreen;
    if (viewType === "legacy") {
      const { default: viewParams } = fieldMapping;
      const paramData = viewParams.reduce((acc, item) => {
        const resolver = item["resolver"] ? LegacyResolvers[item["resolver"]] : null ;
        acc[item["legacy"]] = resolver ? resolver(formData[item["source"]]): formData[item["source"]];
        return acc;
      }, {});
      const message = {
        message: "navigate-to-presto",
        programCode: LEGACY_SCREEN_VIEW[screenNumber],
        parameters: paramData,
      };
      console.log("message", message);
      window.top?.postMessage(message, "*");
    } else {
      showModal(lookupScreen, { params }, null, formData, true);
    }
  };

  const getPageTitle = useCallback(() => {
    const [screenTitle, screenNumber] = isAddMode(currentMode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>-</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  }, [currentMode]);
  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";
    let infoChanged = true;

    if (isAddMode(currentMode)) {
      url = "api/dsdDeductibleSchDtl";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/dsdDeductibleSchDtl";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];

      if (
        JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)
      ) {
        infoChanged = false;
      }
    }

    const data = { ...dataForSubmission, screenNumber, infoChanged };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      if (responseStatus.message === NO_CHANGE_OF_INFO) {
                         toast.current.show({
                           severity: "info",
                           summary: "",
                           detail: responseStatus.message,
                           life: 3000,
                         });
                       } else {
                         toast.current.show({
                           severity: "success",
                           summary: "",
                           detail: responseStatus.message,
                           life: 3000,
                         });
      setInitialFormData(responseData);
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        const updatedCurrentState = {
          ...currentState,
          selectedSteps: [{ ...responseData }],
          currentIndex: 0,
          scheduleName: responseData["dscScheduleName"],
          paramsData: {
            dscScheduleName: responseData.dscScheduleName,
            dscBasis: responseData.dscBasis,
            basisDescription: responseData.basisDescription,
            dscStepCount: responseData.dscStepCount,
            dscDescription: responseData.dscDescription,
            dsdCrossOverFlag: responseData.dsdCrossOverFlag,
          }
        };
        navigateToPage(ROUTE_PATHS.EDIT_DEDUCTIBLE_SCHEDULE_STEP, [
          ...previousState,
          { ...updatedCurrentState },
        ]);
      }
      else {
        setInitialFormData(responseData);
      }
    
      try {
        const params = {
          dscScheduleName: responseData.dscScheduleName,
          dsdStepNumber: responseData.dsdStepNumber,
          dsdCrossOverFlag: responseData.dsdCrossOverFlag,
          dsdAccumComponentCode: responseData.dsdAccumComponentCode,
        };
        const urlForValidation =
          "api/dsdDeductibleSchDtl/dsdAccumComponentCode";
        await axios_helper_no_header("GET", urlForValidation, {}, params);
      } catch (validationError) {
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          validationError.data;
        if (displayErrorFields === null) {
          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
        } else {
          setConstraintErrors(displayErrorFields);
        }
      }
    } }catch (error) {
      const { responseStatus: { displayErrorFields = null, message } = {} } =
        error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const patientsPayValidation = () => {
    const params = {
      dscScheduleName: scheduleName,
      dsdStepNumber: selectedSteps[currentIndex].dsdStepNumber,
    };
    axios_helper_no_header(
      "GET",
      "api/dsdDeductibleSchDtl/validateBeforePatientsPay",
      null,
      params
    )
      .then((response) => {
        navigateToPage(PATIENT_PAY_SCHEDULES, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedSteps: [initialFormData.dsdStepNumber],
            description: paramsData.dscDescription,
            stepNumber: initialFormData.dsdStepNumber,
            scheduleName: paramsData.dscScheduleName,
            previousScreen: location.pathname,
            // selectedSchedules:[selectedSchedules[currentIndex]],
            currentIndex: 0,
          },
        ]);
      })
      .catch((error) => {
        console.error("There was an error editing the data!", error);
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      });
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
      keyName.chmod = "View";
      keyName.F7 = "Details Extension";
      keyFunc.F7 = () => {
        navigateToPage(DEDUCTIBLE_SCHEDULE_STEP_DETAIL_EXTENSION, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedSteps: [
              {
                dsdStepNumber: initialFormData.dsdStepNumber,
                dscScheduleName: scheduleName,
                dscDescription: paramsData.dscDescription,
                dsdCrossOverFlag: initialFormData.dsdCrossOverFlag,
              },
            ],
            // selectedSchedules:[selectedSchedules[currentIndex]],
            previousScreen: location.pathname,
            currentIndex: 0,
          },
        ]);
      };
      keyName.F9 = "Patient Pay Schedules";
      keyFunc.F9 = () => {
        patientsPayValidation();
      };
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
      keyName.F7 = "Details Extension";
      keyFunc.F7 = () => {
        navigateToPage(DEDUCTIBLE_SCHEDULE_STEP_DETAIL_EXTENSION, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedSteps: [
              {
                dsdStepNumber: initialFormData.dsdStepNumber,
                dscScheduleName: scheduleName,
                dsdCrossOverFlag: initialFormData.dsdCrossOverFlag,
              },
            ],
            // selectedSchedules:[selectedSchedules[currentIndex]],
            previousScreen: location.pathname,
            currentIndex: 0,
          },
        ]);
      };
      keyName.F9 = "Patient Pay Schedules";
      keyFunc.F9 = () => {
        patientsPayValidation();
      };
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex,initialFormData]);

  // useEffect(()=>{
  //   if(currentIndex!=initialIndex){
  //     setParamsData({
  //       dscScheduleName: scheduleName,
  //       dscDescription: paramsData.dscDescription,
  //       dscBasis: paramsData.dscBasis,
  //       basisDescription: "",
  //       dscStepCount: paramsData.dscStepCount,
  //     });
  //   }
  // },[currentIndex]);

  useEffect(() => {
    const fetchInitialData = async () => {
      const dsdStepNumber = selectedSteps[currentIndex]?.dsdStepNumber;
      const url = isAddMode(currentMode)
        ? `api/dsdDeductibleSchDtl/initialFormData/RCDSD003?dscScheduleName=${encodeURIComponent(
            scheduleName
          )}`
        : `api/dsdDeductibleSchDtl/${encodeURIComponent(
            scheduleName
          )}?dsdStepNumber=${dsdStepNumber}`;
      const { responseData } = await axios_helper_no_header("GET", url);
      setInitialFormData(responseData);
    };

    fetchInitialData();
  }, [mode, currentIndex]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          viewLookupDetails={viewLookupDetails}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
          fetchLookupData={fetchLookupData}
          lookupData={lookupData}
        />
      </div>
    </div>
  );
};

export default DeductibleScheduleStepsForm;
